import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Clock, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { HERO_CONTENT } from '../../data/mock';

const iconMap = {
  Truck: Truck,
  Clock: Clock,
  CheckCircle: CheckCircle,
};

const HeroSection = () => {
  return (
    <section className="relative min-h-[50vh] overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_transa-installer/artifacts/gv72fe4r_file_0000000010707206b0a790e738f409b9.png"
          alt="Transa delivery van"
          className="w-full h-full object-cover object-center"
        />
        {/* Gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-white/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-transparent to-white/90" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12 lg:py-14">
        <div className="max-w-2xl">
          {/* Main Content */}
          <div className="animate-fade-in-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#111111] leading-tight">
              {HERO_CONTENT.headline}
            </h1>
            <p className="mt-6 text-lg md:text-xl text-[#475569] leading-relaxed">
              {HERO_CONTENT.subheadline}
            </p>

            {/* Benefits */}
            <div className="mt-8 space-y-4">
              {HERO_CONTENT.benefits.map((benefit, index) => {
                const IconComponent = iconMap[benefit.icon];
                return (
                  <div 
                    key={index} 
                    className="flex items-center gap-3 animate-fade-in-up"
                    style={{ animationDelay: `${(index + 1) * 100}ms` }}
                  >
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#0D9488]/10 backdrop-blur-sm flex items-center justify-center">
                      <IconComponent className="w-5 h-5 text-[#0D9488]" />
                    </div>
                    <span className="text-[#111111] font-medium">{benefit.text}</span>
                  </div>
                );
              })}
            </div>

            {/* CTAs */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link to="/book/waste">
                <Button size="lg" className="w-full sm:w-auto bg-[#0D9488] hover:bg-[#0F766E] text-white px-8 py-6 text-lg font-semibold shadow-lg shadow-[#0D9488]/25">
                  Collect My Packaging
                </Button>
              </Link>
              <Link to="/subscribe">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-[#7C3AED] bg-white/80 backdrop-blur-sm text-[#7C3AED] hover:bg-[#7C3AED] hover:text-white px-8 py-6 text-lg">
                  Become a Subscriber
                </Button>
              </Link>
            </div>

            {/* Trust Line */}
            <p className="mt-8 text-sm text-[#64748B]">
              {HERO_CONTENT.trustLine}
            </p>
          </div>
        </div>

        {/* Floating Stats Card */}
        <div className="hidden lg:block absolute bottom-8 right-8 xl:right-16 animate-fade-in delay-300">
          <div className="bg-white/90 backdrop-blur-md rounded-2xl shadow-xl p-6 border border-white/50">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#F0FDF4] rounded-full flex items-center justify-center">
                <CheckCircle className="w-6 h-6 text-[#22C55E]" />
              </div>
              <div>
                <p className="text-sm text-[#64748B]">Collection booked</p>
                <p className="text-lg font-bold text-[#111111]">We handle the rest</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
